module.exports = __webpack_public_path__ + "static/media/Full-Stack-Developer-Certification.8e08ccc9.png";